function Cell({ children, className = "", ...props }) {
	return (
		<td {...props} className={`main_table_item ${className}`}>
			{children}
		</td>
	);
}

export default Cell;
